import React from 'react';
import { Retention } from './Charts';
import { fullDate, rate } from './format';

const MARKS = [0, 25, 50, 75, 100];

function VideoCard({ video, since }) {
  const points = MARKS.map((mark) => ({ mark, n: video.marks?.[mark] || 0 }));
  const film = video.id.startsWith('film');
  return (
    <section className="ck-card ck-video">
      <header className="ck-card-head">
        <h2>{video.label}</h2>
        <p>{film ? 'Lancé avec le son (l’aperçu muet ne compte pas)' : 'Lecture auto à l’écran, au moins 1 s'}</p>
      </header>
      {video.started === 0 ? (
        <p className="ck-empty">
          {since ? `Collecte démarrée le ${fullDate(since)}. Personne ne l’a encore lancée.` : 'Collecte démarrée : en attente de la première visite.'}
        </p>
      ) : (
        <>
          <div className="ck-video-top">
            <div><span>{film ? 'Lancée' : 'Vue'}</span><b>{video.started}</b></div>
            <div><span>Jusqu’au bout</span><b>{video.marks[100]}</b><small>{rate(video.marks[100], video.started)}</small></div>
          </div>
          <Retention points={points} />
          <ol className="ck-video-steps">
            {points.map((point) => (
              <li key={point.mark}>
                <span>{point.mark === 0 ? 'Démarrage' : point.mark === 100 ? 'Fin' : `${point.mark} %`}</span>
                <b>{point.n}</b>
                <small>{rate(point.n, video.started)}</small>
              </li>
            ))}
          </ol>
          <p className="ck-foot">
            Parmi les <b>{video.past50}</b> qui ont passé 50 %, <b>{video.joinedAfter50}</b> ont cliqué rejoindre ({rate(video.joinedAfter50, video.past50)}).
            {video.below50 > 0 && ` Avant 50 % : ${video.joinedBelow50} sur ${video.below50} (${rate(video.joinedBelow50, video.below50)}).`}
          </p>
        </>
      )}
    </section>
  );
}

export default function Videos({ videos }) {
  const list = videos?.list || [];
  const since = videos?.since || null;
  return (
    <div className="ck-view">
      <p className="ck-lead">
        {since ? `Suivi par vidéo depuis le ${fullDate(since)}.` : 'Suivi par vidéo branché : il démarre à la prochaine visite.'}
        {' '}Hors toi, Nice et Antibes. Une personne compte une fois par vidéo et par visite, au point le plus loin qu’elle a atteint.
      </p>
      <div className="ck-grid ck-grid-3">
        {list.map((video) => <VideoCard key={video.id} video={video} since={since} />)}
      </div>
    </div>
  );
}
